import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography, useMediaQuery } from '@mui/material';
import React, { memo } from 'react';

import { useIdentityContext, useVideoContext } from '../../hooks';
import { backgroundConfig } from '../../hooks/video-hooks/useBackgroundSettings';
import { UserRoleName } from '../../services/identity/types/UserProfile';
import BackgroundThumbnail from '../BackgroundThumbnail/BackgroundThumbnail';
import styles from './styles.module.scss';

const SelectBackgroundModal: React.FC = () => {
  const { isBackgroundSelectionOpen, setIsBackgroundSelectionOpen } = useVideoContext();
  const { imageNames, images } = backgroundConfig;
  const { userInfo } = useIdentityContext();

  const fullScreen = useMediaQuery('(max-width:768px)');

  return (
    <Dialog
      open={Boolean(isBackgroundSelectionOpen)}
      onClose={() => setIsBackgroundSelectionOpen(false)}
      fullScreen={fullScreen}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 2000,
        '& .MuiDialog-paper': {
          borderRadius: 4,
        },
      }}
      PaperProps={{
        sx: {
          width: fullScreen ? '100%' : 760,
          maxWidth: fullScreen ? '100%' : 760,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
          px: 2.5,
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: 18 }}>Background</Typography>

        <IconButton
          aria-label="Close background dialog"
          onClick={() => setIsBackgroundSelectionOpen(false)}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2.5, pb: 2.5 }}>
        {/* None + Blur */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 3,
            mb: 3,
            ...(userInfo?.role.name === UserRoleName.Patient ? { px: fullScreen ? 1 : 4, pt: 1 } : {}),
          }}
          className={styles.topRow}
        >
          <BackgroundThumbnail thumbnail="none" name="None" />
          <BackgroundThumbnail thumbnail="blur" name="Blur" />
        </Box>

        {/* Images for non-patient */}
        {userInfo?.role.name !== UserRoleName.Patient && (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
            }}
            className={styles.gridRow}
          >
            {images.map((image, index) => (
              <BackgroundThumbnail
                thumbnail="image"
                name={imageNames[index]}
                index={index}
                imagePath={image}
                key={image}
              />
            ))}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default memo(SelectBackgroundModal);
